import { fromJS } from 'immutable'

import { forceImmutable } from '../util/immutableUtils'

import { getAppStatus } from './actions'

let defaultState = fromJS({    
    appList: null
})

export default function appStatus(state = defaultState, action) {
    state = forceImmutable(state) // Force immutable in case of rehydration

    switch (action.type) {
        case getAppStatus.event.success:                        
            return state.set('appList', action.payload)
        default:
            return state
    }
}

export const selectAppList = state => state.appStatus.get("appList")


// WEBPACK FOOTER //
// ./client/src/appStatus/reducer.js